import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import ScrollToTop from "react-scroll-to-top";
import RouteScrollToTop from "./helper/RouteScrollToTop";
import AboutPage from "./pages/AboutPage";
import CareersPage from "./pages/CareersPage";
import ContactPage from "./pages/ContactPage";
import FaqPage from "./pages/FaqPage";
import HomePageOne from "./pages/HomePageOne";
import ProductDetailsPage from "./pages/ProductDetailsPage";
import ProductsPage from "./pages/ProductsPage";
import ServiceAreasPage from "./pages/ServiceAreasPage";
import ServiceDetailsPage from "./pages/ServiceDetailsPage";
import ServicePage from "./pages/ServicePage";

function App() {
  return (
    <BrowserRouter>
      <RouteScrollToTop />
      <ScrollToTop smooth color="#0b84c6" />
      <Routes>
        <Route path="/" element={<HomePageOne />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicePage />} />
        <Route path="/services/:slug" element={<ServiceDetailsPage />} />
        <Route path="/products" element={<ProductsPage />} />
        <Route path="/products/:slug" element={<ProductDetailsPage />} />
        <Route path="/service-areas" element={<ServiceAreasPage />} />
        <Route path="/faq" element={<FaqPage />} />
        <Route path="/careers" element={<CareersPage />} />
        <Route path="/contact" element={<ContactPage />} />
        <Route path="/service" element={<Navigate to="/services" replace />} />
        <Route path="/shop" element={<Navigate to="/products" replace />} />
        <Route path="/ro-water-purifier-repair-service-delhi.html" element={<Navigate to="/services/ro-water-purifier-repair-service-delhi" replace />} />
        <Route path="/Products/palak-ro-ultra.html" element={<Navigate to="/products/domestic-ro-water-purifier" replace />} />
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
